module.exports = "data:image/jpeg;base64,/9j/4AAQSkZJRgABAQAAAQABAAD/2wBDAAMCAgMCAgMDAwMEAwMEBQgFBQQEBQoHBwYIDAoMDAsKCwsNDhIQDQ4RDgsLEBYQERMUFRUVDA8XGBYUGBIUFRT/2wBDAQMEBAUEBQkFBQkUDQsNFBQUFBQUFBQUFBQUFBQUFBQUFBQUFBQUFBQUFBQUFBQUFBQUFBQUFBQUFBQUFBQUFBT/wAARCAANAAoDASIAAhEBAxEB/8QAFgABAQEAAAAAAAAAAAAAAAAABgIH/8QAJhAAAQQBAgUFAQAAAAAAAAAAAQIDBAURITEABgcSQQgTM1FSYv/EABQBAQAAAAAAAAAAAAAAAAAAAAD/xAAUEQEAAAAAAAAAAAAAAAAAAAAA/9oADAMBAAIRAxEAPwDKpPRy2l2D6eZIrtKJGbKpkvPe6xNjHJKARjCt1a48aEEZivr4zMCM2LB7CGkpHbtoBtrw39TnUCy53j03I6248WvqksuB/tK3HVFnt11GBhWw+t/HAym6XrRUQUi3XgMNj4T+R/fAf//Z"


//////////////////
// WEBPACK FOOTER
// ./static/Resized_Images/00343r.jpg
// module id = xl4x
// module chunks = 1